<template>
    <VJoyWrapper :align="'center'" column-gap="1" no-margin>
        <CircleProgressBar :completion-percentage="percentage" :color="skillsCounterColor" />
        <template v-if="remaining > 0">{{ labelRemaining }}</template>
        <template v-else-if="remaining < 0"></template>
        <template v-else>{{ labelFilled }}</template>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {computed, toRef} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyWrapper} from '@maltjoy/core-vue';
    import CircleProgressBar from '~/components/_common/counter/CircleProgressBar.vue';

    type SkillsCounterProps = {
        limit: number;
        count: number;
        labelRemaining?: string;
        labelFilled?: string;
    };

    const props = defineProps<SkillsCounterProps>();

    // Composables
    const {t} = useTranslation();

    // Refs
    const count = toRef(props, 'count');

    // Computed values
    const labelRemaining = computed(
        (): string => props.labelRemaining ?? t('profile.features.skills.counter.label.remaining', {remaining: remaining.value}),
    );
    const labelFilled = computed((): string => props.labelFilled ?? t('profile.features.skills.counter.label.filled', {remaining}));
    const remaining = computed((): number => props.limit - count.value);
    const percentage = computed((): number => Math.min((count.value / props.limit) * 100, 100));
    const limitExceeded = computed((): boolean => count.value > props.limit);
    const skillsCounterColor = computed((): string => {
        if (limitExceeded.value) {
            return 'var(--joy-color-primary-70)';
        }
        return 'var(--joy-color-tertiary-50)';
    });
</script>
